const FilterIcon = () => (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5 0C2.77614 -1.20705e-08 3 0.223858 3 0.5L3 3C3 3.27614 2.77614 3.5 2.5 3.5C2.22386 3.5 2 3.27614 2 3L2 0.5C2 0.223858 2.22386 1.20707e-08 2.5 0Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.50001 8C2.77615 8 3.00001 8.22386 3.00001 8.5L3 15.4972C3 15.7734 2.77614 15.9972 2.5 15.9972C2.22386 15.9972 2 15.7734 2 15.4972L2.00001 8.5C2.00001 8.22386 2.22386 8 2.50001 8Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 9.99994C13.7761 9.99994 14 10.2238 14 10.4999V15.4971C14 15.7733 13.7761 15.9971 13.5 15.9971C13.2239 15.9971 13 15.7733 13 15.4971V10.4999C13 10.2238 13.2239 9.99994 13.5 9.99994Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 0C13.7761 -1.20705e-08 14 0.223858 14 0.5V5C14 5.27614 13.7761 5.5 13.5 5.5C13.2239 5.5 13 5.27614 13 5V0.5C13 0.223858 13.2239 1.20707e-08 13.5 0Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0C8.27614 -1.3128e-07 8.5 0.223857 8.5 0.5L8.5 8.5C8.5 8.77614 8.27615 9 8 9C7.72386 9 7.5 8.77614 7.5 8.5L7.5 0.5C7.5 0.223858 7.72386 1.01478e-07 8 0Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 13C8.27614 13 8.5 13.2239 8.5 13.5V15.5C8.5 15.7761 8.27614 16 8 16C7.72386 16 7.5 15.7761 7.5 15.5V13.5C7.5 13.2239 7.72386 13 8 13Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 4.5C0 3.67157 0.671573 3 1.5 3H3.5C4.32843 3 5 3.67157 5 4.5V7C5 7.82843 4.32843 8.5 3.5 8.5H1.5C0.671573 8.5 0 7.82843 0 7V4.5ZM1.5 4C1.22386 4 1 4.22386 1 4.5V7C1 7.27614 1.22386 7.5 1.5 7.5H3.5C3.77614 7.5 4 7.27614 4 7V4.5C4 4.22386 3.77614 4 3.5 4H1.5Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.5 10C5.5 9.17157 6.17157 8.5 7 8.5H9C9.82843 8.5 10.5 9.17157 10.5 10V12.5C10.5 13.3284 9.82843 14 9 14H7C6.17157 14 5.5 13.3284 5.5 12.5V10ZM7 9.5C6.72386 9.5 6.5 9.72386 6.5 10V12.5C6.5 12.7761 6.72386 13 7 13H9C9.27614 13 9.5 12.7761 9.5 12.5V10C9.5 9.72386 9.27614 9.5 9 9.5H7Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 6.5C11 5.67157 11.6716 5 12.5 5H14.5C15.3284 5 16 5.67157 16 6.5V9C16 9.82843 15.3284 10.5 14.5 10.5H12.5C11.6716 10.5 11 9.82843 11 9V6.5ZM12.5 6C12.2239 6 12 6.22386 12 6.5V9C12 9.27614 12.2239 9.5 12.5 9.5H14.5C14.7761 9.5 15 9.27614 15 9V6.5C15 6.22386 14.7761 6 14.5 6H12.5Z"
            fill="currentColor"
        />
    </svg>
);

export default FilterIcon;
